export default __webpack_public_path__ + "static/media/android-status-bar.49fa7f06.svg";